import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getIssues } from '../../services/issue';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';

const Issues = ({ channelId = null, location, match }) => {
  const dispatch = useDispatch();
  const [issues, setIssues] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location && location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayIssues();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const displayIssues = async () => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };

      const { data: issues } = await getIssues(page, params);

      setIssues(issues.rows);
      setTotalItems(issues.count);
      setTotalPages(issues.pages);
      setPage(issues.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['subject', 'isPublic', 'isPublished', 'isSendScheduled', 'forMembers', 'forNonMembers', 'channelId', 'userId'];

  const SearchBoxHeaders = ['subject', 'id', 'channelId', 'userId', 'slug', 'uid'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="issues-container">
        <h1>Issues ({totalItems})</h1>

        {!channelId && (
          <SearchBox
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        )}
      </div>

      <DataTable
        data-testid="issuesTable"
        useUid={true}
        head={headers}
        body={issues}
        bodyColumn={headers}
        action={true}
        linkPath={'issues'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Issues;
